import { Filter } from 'app/components/filters/types';

export const getOptionTypeValue = (filter: Filter) => {
  const initialOptionType = filter.initialValue
    && filter.initialValue.length > 0
    && Array.isArray(filter.initialValue)
    && !!filter.initialValue[0]
    && filter.initialValue[0].hasOwnProperty('type')
    && !filter.initialValue[0].hasOwnProperty('value')
    && filter.initialValue[0];
  return filter.optionType
    || (initialOptionType && initialOptionType.type);
};

export const getSubOptionTypeValue = (filter: Filter) => {
  const initialSubOptionType = filter.initialValue
    && filter.initialValue.length > 0
    && Array.isArray(filter.initialValue)
    && !!filter.initialValue[0]
    && filter.initialValue[0].hasOwnProperty('subOptionTypes')
    && filter.initialValue[0];

  return filter.subOptionTypes && filter.subOptionTypes.length > 0 ? filter.subOptionTypes :
    (filter.subOptionTypes === undefined ? [] : initialSubOptionType && initialSubOptionType.subOptionTypes);
};
